export default __webpack_public_path__ + "static/password-forget-85f45ca1e8eccb6d2171e16976f6aa39.jpg";